import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';

interface IMarkedField {
  appendShowMarkCondition?: (values: IKnmForm, availableUnplannedActivities: boolean) => boolean;
}

export const isFieldRequiredForNextStatusesInFillInProcess = (
  fieldName: string | undefined,
  values: IKnmForm,
  availableUnplannedActivities: boolean,
): boolean => {
  if (!fieldName) {
    return false;
  }

  const idRegex = /\[\d+]/gi;
  const fieldNameTemplate = fieldName?.replaceAll(idRegex, '[{id}]');

  if (!fieldNameTemplate || !fieldsRequiredForNextStatusesInFillInProcess[fieldNameTemplate]) {
    return false;
  }

  const markedField = fieldsRequiredForNextStatusesInFillInProcess[fieldNameTemplate];

  return (
    !markedField.appendShowMarkCondition || markedField.appendShowMarkCondition(values, availableUnplannedActivities)
  );
};

const fieldsRequiredForNextStatusesInFillInProcess: Record<string, IMarkedField> = {
  dateTimeDecision: {},
  numberDecision: {},
  fioSigner: {},
  titleSigner: {},
  placeDecision: {
    appendShowMarkCondition: values => !values.notInFIAS,
  },
  manualAddress: {
    appendShowMarkCondition: values => !!values.notInFIAS,
  },
  region: {
    appendShowMarkCondition: values => !!values.notInFIAS,
  },
  directDurationDays: {
    appendShowMarkCondition: values => !values.durationHours && values.kindKnm?.code !== KnmKindCodesEnum.DP,
  },
  durationHours: {
    appendShowMarkCondition: values => !values.directDurationDays && values.kindKnm?.code !== KnmKindCodesEnum.DP,
  },
  durationDays: {},
  reasonsErknm: {},
  objectsErknm: {},
  organizations: {},
  'organizations[{id}].organizationName': {
    appendShowMarkCondition: values => !!values.organizations?.some(org => !org.organizationName),
  },
  interactionCategory: {
    appendShowMarkCondition: values =>
      (values.kindKnm?.code === KnmKindCodesEnum.MZ ||
        values.kindKnm?.code === KnmKindCodesEnum.KZ ||
        values.kindKnm?.code === KnmKindCodesEnum.IV ||
        values.kindKnm?.code === KnmKindCodesEnum.VP) &&
      !values.interactionCategory,
  },
  eventsErknm: {},
  requirementsNpaErknm: {
    appendShowMarkCondition: values => !values.docTarget?.length,
  },
  docTarget: {
    appendShowMarkCondition: values => !values.requirementsNpaErknm?.length,
  },
  places: {
    appendShowMarkCondition: values => values.kindKnm?.code !== KnmKindCodesEnum.DP,
  },
  dataContent: {},
  reasonDocuments: {},
  'eventsErknm[{id}].submittedDocuments': {},
  'approvedOnPaperDocuments.attachments': {
    appendShowMarkCondition: values => values.isApprovedOnPaper === true,
  },
};
